import axios, { AxiosError } from 'axios';

import { buildURL } from '../webservice';
import { GiftCardUser } from '../../views/redeem-gift-card/types';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL!;

type RedemptionRequest = {
    code: string;
    user: GiftCardUser;
};

type RedemptionResponse = {
    success: boolean;
    error?: string;
};

const redeemGiftCard = async (
    payload: RedemptionRequest
): Promise<RedemptionResponse> => {
    try {
        const url = buildURL(BASE_URL, '/v2/gift-cards/redeem');
        console.log('url:', url);
        const response = await axios.post(url, payload);
        return { success: response.data.success };
    } catch (err) {
        console.error(err);
        if (err instanceof AxiosError) {
            return { success: false, error: err.response?.data?.error };
        }
        return { success: false, error: 'Error interno' };
    }
};

export { redeemGiftCard };
